import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NotAuthorizedComponent } from './shared/components/not-authorized/not-authorized.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { IS_ESS_HOST } from './core/utils/app-host';

// Same login page as New PTM, but signs in to ESS (any LDAP user, no login group check)
const essLoginRoute = {
  loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
  data: { app: 'ess' }
};
const loadEssModule = () => import('./modules/ess/ess.module').then(m => m.EssModule);

// Public ESS page (no login, outside the ESS shell), at the root as in the former ESS dashboard, used by devices
const connectRoute = {
  path: 'connect',
  loadComponent: () => import('./modules/ess/components/connect/connect.component').then(m => m.ConnectComponent),
  title: 'Am I Connected?'
};

/** ESS hostname: ESS only, at the root (/ess URLs are mapped to the root before the app starts) */
const essHostRoutes: Routes = [
  { path: 'login', ...essLoginRoute },
  connectRoute,
  { path: 'not-authorized', component: NotAuthorizedComponent },
  { path: '', loadChildren: loadEssModule },
  { path: '**', component: NotFoundComponent },
];

/**
 * New PTM hostname: New PTM, and ESS under /ess. When the environment has an ESS hostname, /ess URLs are sent there
 * before the app starts, so these ESS routes are only used in environments without one.
 */
const newPtmHostRoutes: Routes = [
  { path: 'ess/login', ...essLoginRoute },
  connectRoute,
  // Released under /ess in v2.0.0
  { path: 'ess/connect', redirectTo: 'connect', pathMatch: 'full' },
  { path: 'ess', loadChildren: loadEssModule },
  {
    path: '',
    children: [
        {
            path: '',
            loadChildren: () => import('./modules/new-ptm/new-ptm.module').then(main => main.NewPtmModule)			}
    ]
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  { path: 'not-authorized', component: NotAuthorizedComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(IS_ESS_HOST ? essHostRoutes : newPtmHostRoutes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
